import { TOAuthTokenResponse } from '@novafuturltd/core'
import axios, { AxiosPromise } from 'axios'
import client from '../../client/auth'

export const exchangeAuthCodeForToken = (
  code: string,
): AxiosPromise<TOAuthTokenResponse> =>
  axios.post('/api/oauth/token', { code })

export const logout = (): AxiosPromise<any> =>
  client.patch('authentication/logout', {}, {})
